<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'Mypage'
}

</script>



// WEBPACK FOOTER //
// src/My/containers/My.vue